import { render, staticRenderFns } from "./AcknowledgementSigningHseHandbook.vue?vue&type=template&id=60c72917&"
import script from "./AcknowledgementSigningHseHandbook.vue?vue&type=script&lang=ts&"
export * from "./AcknowledgementSigningHseHandbook.vue?vue&type=script&lang=ts&"
import style0 from "./AcknowledgementSigningHseHandbook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VAlert,VBtn,VContent})
